module.exports = __webpack_public_path__ + "smile_white.a9b7e327.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/landing/white/smile_white.png
// module id = 490
// module chunks = 0